import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhatYouGet() {
  const contents = ['Calendario de 30 días con foco por habilidad', '30 actividades con objetivo claro y materiales mínimos', 'Guión simple (qué decir) para cada actividad', '2 variaciones por edad/día (fácil/difícil)', 'Señal de salida para cada juego', 'Guía de uso (regla 15, día perdido, hora ancla)', 'Mantenimiento (cómo armar mes 2 sin pensar)'];
  return <section className="py-14 px-6 bg-[#FFFBF5]" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <div className="grid lg:grid-cols-2 gap-10" data-id="element-154">
          {/* Left Column: What's included */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2D3A4A] mb-8 font-serif" data-id="element-156">
              Qué incluye exactamente
            </h2>
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-[#F5E6D0]" data-id="element-157">
              <ul className="space-y-4" data-id="element-158">
                {contents.map((item, i) => <li key={i} className="flex items-start" data-id="element-159">
                    <div className="bg-[#8B9E7E]/20 p-1 rounded-full mr-3 mt-0.5" data-id="element-160">
                      <Check className="w-4 h-4 text-[#8B9E7E]" data-id="element-161" />
                    </div>
                    <span className="text-[#2D3A4A]" data-id="element-162">{item}</span>
                  </li>)}
              </ul>
              <p className="mt-6 text-sm text-[#2D3A4A]/60 italic border-t border-gray-100 pt-4" data-id="element-163">
                (Si querés, podés sumar hojas imprimibles, pero no depende de
                eso.)
              </p>
            </div>
          </motion.div>

          {/* Right Column: Who is it for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-8" data-id="element-164">
            <div className="bg-[#F5E6D0]/30 p-8 rounded-3xl" data-id="element-165">
              <h3 className="text-xl font-bold text-[#2D3A4A] mb-4 flex items-center" data-id="element-166">
                <span className="bg-[#8B9E7E] text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm" data-id="element-167">
                  SI
                </span>
                Es para vos si:
              </h3>
              <ul className="space-y-3" data-id="element-168">
                {['Tenés un niño de 1 a 4 años', 'Estás usando pantallas más de lo que querés', 'Querés una alternativa realista, corta y repetible', "Te sirve que te digan 'hacé esto hoy' sin vueltas"].map((item, i) => <li key={i} className="flex items-start text-[#2D3A4A]/80 text-sm md:text-base" data-id="element-169">
                    <Check className="w-4 h-4 text-[#8B9E7E] mr-2 mt-1 flex-shrink-0" data-id="element-170" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-171">
              <h3 className="text-xl font-bold text-[#2D3A4A] mb-4 flex items-center" data-id="element-172">
                <span className="bg-gray-300 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm" data-id="element-173">
                  NO
                </span>
                No es para vos si:
              </h3>
              <ul className="space-y-3" data-id="element-174">
                {["Buscás escolarización formal o resultados 'garantizados'", 'Querés actividades largas tipo manualidad de 2 horas', 'No tolerás nada de desorden (acá hay control, no cero)'].map((item, i) => <li key={i} className="flex items-start text-[#2D3A4A]/80 text-sm md:text-base" data-id="element-175">
                    <X className="w-4 h-4 text-gray-400 mr-2 mt-1 flex-shrink-0" data-id="element-176" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}